<template>
  <ol class="breadcrumb">
    <li><router-link :to="{name: 'BrowseGoalsPage'}">Browse</router-link></li>
    <li v-if="subject"><router-link :to="{name: 'BrowseGoalsPage', query: {'subject': subject}}">{{ getGoalSubjectLabelFromValue(subject) }}</router-link></li>
    <li v-if="subjectDomains && subjectDomains.length"><router-link :to="{name: 'BrowseGoalsPage', query: {'subject': subject, 'subjectDomain': subjectDomains[0]}}">{{ subjectDomains[0] }}</router-link></li>
    <li v-if="grades"><router-link :to="{name: 'BrowseGoalsPage', query: {'subject': subject, 'subjectDomain': subjectDomains[0], 'grades': grades}}">Grade {{ gradesStr }}</router-link></li>
    <li class="active">{{ title }}</li>
  </ol>
</template>

<script>
import { noSelMixin } from '@/contentprofile/no_sel_mixins';

export default {
  name: 'GoalBreadcrumbs',
  mixins: [noSelMixin],
  props: {
    subject: {
      type: String,
      required: true
    },
    subjectDomains: {
      type: Array,
      required: true
    },
    grades: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    gradesStr() {
      if (this.grades.length <= 1) {
        return this.grades[0]
      } else {
        return `${this.grades[0]}-${this.grades[this.grades.length - 1]}`
      }
    }
  }
}
</script>
